import React, { useContext } from "react";


//functions
import {
  _t,
  formatPrice,
  getSystemSettings,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { SettingsContext } from "../../../../../contexts/Settings";

const AccountPrint = ({
  name,
  AccountPrint,
  bankPayment,
  totalRowAmount,
  totalRowWhtAmount,
  totalRowTaxAmount,
  totalRowNetAmount,
  newRow
}) => {
  const { t } = useTranslation();

  const {
    //common
    generalSettings,
  } = useContext(SettingsContext);
  const landscapePrintStyles = {
    '@media print': {
      '@page': {
        size: 'landscape',
      },
    },
  };
  return (
    <>
      {/* print */}
      <div className="d-none">
        <div ref={AccountPrint} style={landscapePrintStyles}>
          {bankPayment && bankPayment.doc_no && (
            <div className="fk-print" style={{margin:"20px"}}>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="mx-auto" style={{ width: "90px" }}>
                      <img
                        src={`${getSystemSettings(
                          generalSettings,
                          "type_logo"
                        )}`}
                        style={{ width: "100%" }}
                      />
                    </div>

                    <div className="my-2 xslg-text xlg-print-text-stock print-text-stock text-center text-capitalize print-text-stock--bold">
                      {`${getSystemSettings(
                          generalSettings,
                          "siteName"
                        )}`}
                    </div>

                    <div className="mt-2 mb-3 xslg-text xlg-print-text-stock print-text-stock text-center text-capitalize print-text-stock--bold">
                      {name}
                    </div>

                    <div className="my-2 print-text-stock--bold d-flex print-text-stock justify-content-between text-capitalize ml-2 row">
                      <div className="col-6"> Document No :{" "}{bankPayment.doc_no && bankPayment.doc_no}
                      </div>
                      <div className="col-6">Document Date: {bankPayment.doc_date && bankPayment.doc_date?.toDateString()}</div>
                    </div>
                    <div className="my-2 print-text-stock text-capitalize print-text-stock--bold d-flex justify-content-between ml-2 row">
                      <div className="col-6">{bankPayment?.transactionAccount && `Transaction Account` } {bankPayment.transactionAccount && bankPayment?.transactionAccount}</div>
                      {
                        bankPayment?.branch_name && (
                          <div className="col-6">
                            Branch :{" "}
                            {bankPayment.branch_name && bankPayment.branch_name}
                          </div>
                        )
                      }
                    </div>

                    <div className="my-2 mb-3 print-text-stock--bold d-flex print-text-stock justify-content-between text-capitalize ml-2 row">
                      <div className="col-6">
                        {(name === "Bank Receipt" || name === "Cash Receipt") ? "Customer" : "Supplier"}: 
                        {(name === "Bank Receipt" || name === "Cash Receipt") ? bankPayment?.customer_name : (bankPayment?.supplier_name || "")}
                      </div>
                      <div className="col-6 text-break">
                        Remarks :{" "}
                        {bankPayment?.remarks}
                      </div>
                    </div>
                    
                    {totalRowAmount !== null && newRow && newRow?.length > 0 && (
                        <div className=" mt-3">
                          <table className="table table-bordered print-text-stock">
                            <thead className="align-middle">
                              <tr>
                                <th
                                  scope="col"
                                  className="text-capitalize align-middle text-center border-dark border-1 border table_child_ordertype"
                                >
                                  {_t(t("Account"))}
                                </th>
                                {
                                  (name === "Journal Voucher" || name === "Opening Account") && (
                                    <th
                                      scope="col"
                                      className="text-capitalize align-middle text-center border-dark border-1 border"
                                    >
                                      {_t(t("Supplier Name"))}
                                    </th>
                                  )
                                }
                                <th
                                  scope="col"
                                  className="text-capitalize align-middle text-center border-dark border-1 border"
                                >
                                  {_t(t("Remarks"))}
                                </th>
                                {newRow?.[0]?.ref_doc_identity && (
                                  <th
                                    scope="col"
                                    className="text-capitalize align-middle text-center border-dark border-1 border"
                                  >
                                    {_t(t("PI Ref"))}
                                  </th>
                                )}
                                {bankPayment?.transactionAccount ? (
                                  <>
                                    <th
                                      scope="col"
                                      className="text-capitalize align-middle text-center border-dark border-1 border"
                                    >
                                      {_t(t("Amount"))}
                                    </th>

                                    <th
                                      scope="col"
                                      className="text-capitalize align-middle text-center border-dark border-1 border"
                                    >
                                      {_t(t("Tax Amount"))}
                                    </th>

                                    <th
                                      scope="col"
                                      className="text-capitalize align-middle text-center border-dark border-1 border"
                                    >
                                      {_t(t("WHT Amount"))}
                                    </th>

                                    <th
                                      scope="col"
                                      className="text-capitalize align-middle text-center border-dark border-1 border"
                                    >
                                      {_t(t("Net Amount"))}
                                    </th>
                                  </>
                                  ) : (
                                    <>
                                      <th
                                        scope="col"
                                        className="text-capitalize align-middle text-center border-dark border-1 border"
                                      >
                                        {_t(t("Debit"))}
                                      </th>

                                      <th
                                        scope="col"
                                        className="text-capitalize align-middle text-center border-dark border-1 border"
                                      >
                                        {_t(t("Credit"))}
                                      </th>
                                    </>
                                  )
                                } 
                              </tr>
                            </thead>
                            {
                              newRow && newRow?.length > 0 && (
                                newRow.map((item)=>{
                                  return (
                                    <tbody className="align-middle">
                                      <tr>
                                        <td
                                        scope="col"
                                        className="text-capitalize align-middle text-center border-dark border-1 border"
                                        >
                                          {item.level3_name}
                                        </td>
                                        {
                                          (name === "Journal Voucher" || name === "Opening Account") && (
                                            <td
                                            scope="col"
                                            className="text-capitalize align-middle text-center border-dark border-1 border"
                                            >
                                              {item?.supplier || "-"}
                                            </td>
                                          )}
                                        <td
                                        scope="col"
                                        className="text-capitalize align-middle text-center border-dark border-1 border"
                                        >
                                          {item.remarks ? item.remarks : "-"}
                                        </td>
                                        {newRow?.[0]?.ref_doc_identity && (
                                          <td
                                            scope="col"
                                            className="text-capitalize align-middle text-center border-dark border-1 border"
                                          >
                                            {item?.ref_doc_identity ?? ""}
                                          </td>
                                        )}
                                        {bankPayment?.transactionAccount ? (
                                          <>
                                          <td
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-dark border-1 border"
                                          >
                                            {item.amount}
                                          </td>
                                          <td
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-dark border-1 border"
                                          >
                                            {item.other_tax_amount}
                                          </td>
                                          <td
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-dark border-1 border"
                                          >
                                            {item.wht_amount}
                                          </td>
                                          <td
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-dark border-1 border"
                                          >
                                            {item.net_amount}
                                          </td>
                                        </>)
                                        : <>
                                          <td
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-dark border-1 border"
                                          >
                                            {item.debit}
                                          </td>
                                          <td
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-dark border-1 border"
                                          >
                                            {item.credit}
                                          </td>
                                        </>}
                                      </tr>
                                    </tbody>
                                  )
                                })
                              )
                            }
                            <tbody className="align-middle">
                              <tr>
                                <th colSpan={(newRow?.[0]?.ref_doc_identity || name === "Journal Voucher" || name === "Opening Account") ? 2 : 1} scope="col"
                                className="text-capitalize align-middle text-center border-dark border-1 border"
                                ></th>
                                <th  scope="col"
                                className="text-capitalize align-middle text-center border-dark border-1 border"
                                >Grand Total</th>

                                {bankPayment?.transactionAccount ? (<>
                                  <th
                                  scope="col"
                                  className="text-capitalize align-middle text-center border-dark border-1 border"
                                  >
                                    {totalRowAmount}
                                  </th>
                                  <th
                                  scope="col"
                                  className="text-capitalize align-middle text-center border-dark border-1 border"
                                  >
                                    {totalRowTaxAmount}
                                  </th>
                                  <th
                                  scope="col"
                                  className="text-capitalize align-middle text-center border-dark border-1 border"
                                  >
                                    {totalRowWhtAmount}
                                  </th>
                                  <th
                                  scope="col"
                                  className="text-capitalize align-middle text-center border-dark border-1 border"
                                  >
                                    {totalRowNetAmount}
                                  </th></>)
                                :
                                <>
                                  <th
                                  scope="col"
                                  className="text-capitalize align-middle text-center border-dark border-1 border"
                                  >
                                    {totalRowAmount}
                                  </th>
                                  <th
                                  scope="col"
                                  className="text-capitalize align-middle text-center border-dark border-1 border"
                                  >
                                    {totalRowNetAmount}
                                  </th>
                                </>}
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default AccountPrint
